import { useContext } from 'react';
import LocaleContext from './locale-context';
export default function (props) {
  var _useContext = useContext(LocaleContext),
      formatMessage = _useContext.formatMessage;

  return formatMessage(props);
}